import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { publicApi } from "../lib/api";
import PageBlocks from "../components/PageBlocks";
import Seo from "../components/Seo";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    publicApi.page(slug)
      .then(setPage)
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center text-slate-400">Loading...</div>;

  if (notFound || !page) {
    return (
      <div className="min-h-[50vh] flex flex-col items-center justify-center px-6 text-center">
        <Seo title="Page not found" noindex />
        <h1 className="font-display font-extrabold text-4xl text-navy mb-3">Page not found</h1>
        <p className="text-slate-500 mb-6">This page may have moved or isn't published yet.</p>
        <Link to="/" className="inline-flex items-center gap-2 text-orange font-bold"><ArrowLeft size={16} /> Back home</Link>
      </div>
    );
  }

  const hasHero = (page.blocks || []).some((b) => b.type === "hero");

  return (
    <div>
      <Seo title={page.title} description={page.meta_description || ""} />
      {!hasHero && (
        <section className="numbers-pattern text-white">
          <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-20">
            <h1 className="font-display font-extrabold text-4xl md:text-6xl uppercase leading-[0.95]">{page.title}</h1>
          </div>
        </section>
      )}
      <PageBlocks blocks={page.blocks || []} pageTitle={page.title} />
    </div>
  );
}
